import { __awaiter, __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, StorageService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { Geolocation } from '@ionic-native/geolocation/ngx';

const SPE_N_IMPORT_TRANSACTION_FILES = '/spe-n-import-transaction-files';
let SpeNImportTransactionFilesProxy = class SpeNImportTransactionFilesProxy {
    constructor(api, geolocation, storage) {
        this.api = api;
        this.geolocation = geolocation;
        this.storage = storage;
        this.altitude = '';
        this.accuracy = '';
        this.latitude = '';
        this.longitude = '';
        this.xdeviceid = '';
        this.getLocation();
    }
    getLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.get('uuidAccountPaymentDevice')
                .then(res => {
                if (res) {
                    this.xdeviceid = res;
                }
            });
            yield this.geolocation
                .getCurrentPosition()
                .then((resp) => {
                this.geolocationInfo = resp.coords;
                if (this.geolocationInfo.altitude != null) {
                    this.altitude = this.geolocationInfo.altitude.toString();
                }
                if (this.geolocationInfo.accuracy != null) {
                    this.accuracy = this.geolocationInfo.accuracy.toString();
                }
                if (this.geolocationInfo.latitude != null) {
                    this.latitude = this.geolocationInfo.latitude.toString();
                }
                if (this.geolocationInfo.longitude != null) {
                    this.longitude = this.geolocationInfo.longitude.toString();
                }
            })
                .catch((error) => {
                console.log('Erro ao pegar localização: ', error);
            });
        });
    }
    getExtraheader() {
        return [
            { name: 'X-Lat', value: this.latitude },
            { name: 'X-Lon', value: this.longitude },
            { name: 'X-Acc', value: this.accuracy },
            { name: 'X-Alt', value: this.altitude }
        ];
    }
    getImportFiles(userProfileInfo, filter) {
        const uri = `${SPE_N_IMPORT_TRANSACTION_FILES}/v1/transactions-file/token`;
        return this.api.get(uri);
    }
    uploadFile(data, uuidAccountPayment) {
        const uri = `${SPE_N_IMPORT_TRANSACTION_FILES}/v1/import-transactions`;
        return this.api.post(uri, data, null, this.getExtraheader());
    }
    translateFile(data, uuidAccountPayment) {
        const uri = `${SPE_N_IMPORT_TRANSACTION_FILES}/v1/import-transactions/file/translate-only`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
    getDownloadLayoutFileCsv(fileType) {
        const uri = `${SPE_N_IMPORT_TRANSACTION_FILES}/templates/template_${fileType}.csv`;
        return this.api.getBlob(uri);
    }
    getDownloadResumeFile(uuidTransactionFileId, type) {
        const uri = `${SPE_N_IMPORT_TRANSACTION_FILES}/v1/transactions/reports/${uuidTransactionFileId}?type=${type}`;
        return this.api.getBlob(uri);
    }
};
SpeNImportTransactionFilesProxy.ctorParameters = () => [
    { type: ApiService },
    { type: Geolocation },
    { type: StorageService }
];
SpeNImportTransactionFilesProxy = __decorate([
    Injectable()
], SpeNImportTransactionFilesProxy);

let UiPxTransactionFilesModule = class UiPxTransactionFilesModule {
};
UiPxTransactionFilesModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [SpeNImportTransactionFilesProxy],
    })
], UiPxTransactionFilesModule);

/*
 * Public API Surface of ui-px-pre-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SpeNImportTransactionFilesProxy, UiPxTransactionFilesModule };
//# sourceMappingURL=wlp-ui-px-import-files.js.map
